import { IRoleListTableLang } from '../../../types/lang'

export const roleListTableLang: IRoleListTableLang = {
	role_list_table: {
		column_id: 'ID_ru',
		column_code: 'Code_ru',
		column_name: 'Name_ru',
		column_is_buyer: 'Buyer_ru',
		column_in_group: 'Group_ru',
		column_is_team: 'Team_ru',
		column_team_report: 'Team Report_ru',
		column_permissions: 'Permissions_ru',
		column_is_system: 'System_ru',
		column_access: 'Access_ru'
	}
}